import { AppRouteGroup } from 'utils/routing/AppRouteGroup';

export const userDashboardRouteGroup = new AppRouteGroup({
  path: '/dashboard',
});

export const userDashboardSavedItemsRoute = userDashboardRouteGroup.route({
  path: 'saved-items',
  searchParams: ['tab', 'page'],
});
